import { Box, Container, Typography, Card, Fade } from "@mui/material";
import Navbar from "../../components/navbar/NavBar";
import Footer from "../../components/navbar/Footer";

const BlogPost = () => {
  const post = {
    title: "Why is Vastu Shastra Essential for Modern Homes?",
    date: "February 10th 2025",
    readTime: "3 min read",
    author: "Er. Santos Pudasaini",
    content: [
      {
        type: "paragraph",
        content:
          "Vastu Shastra, the ancient Indian science of architecture and design, has become increasingly relevant in our modern world. As we spend more time in our homes than ever before, the principles of Vastu can help create living spaces that promote harmony, prosperity, and well-being.",
      },
      {
        type: "heading",
        content: "The Science Behind Vastu",
      },
      {
        type: "paragraph",
        content:
          "At its core, Vastu Shastra is based on the understanding of energy flows and natural forces. It considers how the five elements (earth, water, fire, air, and space) interact within our living spaces. Modern scientific studies have begun to validate many Vastu principles, particularly regarding natural light, ventilation, and their effects on human health.",
      },
      {
        type: "heading",
        content: "Key Benefits of Vastu-Compliant Homes",
      },
      {
        type: "paragraph",
        content:
          "1. Enhanced Mental Well-being: Proper orientation and room placement can reduce stress and anxiety, promoting better mental health. The careful consideration of natural light and air flow helps maintain a positive atmosphere.\n\n2. Improved Physical Health: Vastu-aligned spaces ensure better air quality and natural light distribution, which can boost immunity and overall health.\n\n3. Better Sleep Quality: Bedroom placement according to Vastu principles can lead to improved sleep patterns and better rest.\n\n4. Increased Productivity: Whether working from home or simply managing daily tasks, Vastu-compliant spaces can enhance focus and efficiency.",
      },
      {
        type: "heading",
        content: "Implementing Vastu in Modern Homes",
      },
      {
        type: "paragraph",
        content:
          "Modern implementation of Vastu doesn't require drastic changes. Simple adjustments like furniture placement, color schemes, and the organization of spaces can make a significant difference. The key is to balance ancient wisdom with contemporary needs, creating spaces that are both functional and harmonious.",
      },
    ],
    image:
      "https://res.cloudinary.com/duaz5kg1m/image/upload/v1739479212/What_is_Vastu_2x_gmahch.jpg",
  };

  return (
    <Box sx={{ background: "#ffffff", minHeight: "100vh", color: "#333333" }}>
      <Navbar />

      <Container sx={{ pt: 15, pb: 8 }}>
        <Fade in timeout={1000}>
          <Card sx={{ p: { xs: 3, md: 6 }, borderRadius: 4 }}>
            <Typography variant="subtitle1" sx={{ color: "#666666", mb: 2 }}>
              {post.date} · {post.readTime} · By {post.author}
            </Typography>

            <Typography
              variant="h2"
              component="h1"
              gutterBottom
              sx={{
                color: "#bb0000",
                fontWeight: 700,
                position: "relative",
                mb: 4,
                "&:after": {
                  content: '""',
                  position: "absolute",
                  bottom: -8,
                  left: 0,
                  width: "80px",
                  height: "4px",
                  background: "#bb0000",
                  borderRadius: "2px",
                },
              }}
            >
              {post.title}
            </Typography>

            <Box
              component="img"
              src={post.image}
              alt={post.title}
              sx={{
                width: "100%",
                height: "auto",
                borderRadius: 2,
                mb: 4,
              }}
            />

            {post.content.map((section, index) => (
              <Box key={index} sx={{ mb: 4 }}>
                {section.type === "heading" ? (
                  <Typography
                    variant="h4"
                    component="h2"
                    gutterBottom
                    sx={{
                      color: "#bb0000",
                      fontWeight: 600,
                      mt: 4,
                      mb: 3,
                    }}
                  >
                    {section.content}
                  </Typography>
                ) : (
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#555555",
                      lineHeight: 1.8,
                      fontSize: "1.1rem",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {section.content}
                  </Typography>
                )}
              </Box>
            ))}
          </Card>
        </Fade>
      </Container>
      <Footer />
    </Box>
  );
};

export default BlogPost;
